type Options = Partial<AccordionOptions>;

export interface AccordionElement extends HTMLElement {
  accordion?: Accordion;
}

export interface AccordionOptions {
  allowSecondClickEvents: boolean;
  anchorSelector: string;
  excludeTarget: boolean;
  itemSelector: string;
  listSelector: string;
  firstItemOpen: boolean;
  visibilityClassName: string;
}

export class Accordion {
  static defaults = {
    allowSecondClickEvents: false,
    anchorSelector: '[data-accordion-anchor]',
    closeHandleSelector: '[data-accordion-close]',
    excludeTarget: true,
    firstItemOpen: false,
    itemSelector: '[data-accordion-item]',
    listSelector: '[data-accordion-list]',
    visibilityClassName: 'is-active',
  };
  options: AccordionOptions;
  anchorElements: Element[];
  element: AccordionElement;

  constructor(element: AccordionElement, options: Options) {
    if (!element || element.accordion) {
      return;
    }

    element.accordion = this;
    this.element = element;
    this.options = {
      ...Accordion.defaults,
      ...this.element.dataset,
      ...options,
    };

    this.binding();
  }

  toggleVisibility(element: Element) {
    element.classList.toggle(this.options.visibilityClassName);
  }

  closeOpen(excludeItem?: Element) {
    for (const child of this.anchorElements) {
      if (child !== excludeItem && this.options.excludeTarget) {
        child.classList.remove(this.options.visibilityClassName);
      }
    }
  }

  clickHandler = (event: Event) => {
    const element = event.target as HTMLElement;

    if (
      this.options.allowSecondClickEvents &&
      element.matches(`.${this.options.visibilityClassName}`)
    ) {
      return;
    }

    // Prevent default events on anchor elements
    event.preventDefault();
    this.closeOpen(element);
    this.toggleVisibility(element);
  };

  binding() {
    this.anchorElements = Array.from(
      this.element.querySelectorAll(this.options.anchorSelector),
    );

    this.anchorElements.forEach(child => {
      if (child.matches(this.options.anchorSelector)) {
        child.addEventListener('click', this.clickHandler);
      }
    });

    if (this.options.firstItemOpen) {
      this.toggleVisibility(this.anchorElements[0]);
    }
  }

  destroy() {
    this.element.accordion = undefined;

    this.anchorElements.forEach(child => {
      if (child.matches(this.options.anchorSelector)) {
        child.removeEventListener('click', this.clickHandler);
      }
    });
  }
}
